import { render, staticRenderFns } from "./TeacherHome.vue?vue&type=template&id=1f3bc40a"
import script from "./TeacherHome.vue?vue&type=script&lang=js"
export * from "./TeacherHome.vue?vue&type=script&lang=js"
import style0 from "./TeacherHome.vue?vue&type=style&index=0&id=1f3bc40a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports